import { QUESTIONS_ROUTES } from '../../constants/_routes'
import { formatRoute } from 'react-router-named-routes'
import questionsTypes from '../../constants/questionsTypes'
import { axios } from '../../services'

// 1 unpublish
const unpublish_question_request = () => {
  return {
    type: questionsTypes.publish.request
  }
}

const unpublish_question_success = (response) => {
  return {
    type: questionsTypes.publish.success,
    payload: response.data
  }
}

const unpublish_single_question_success = (response) => {
  return {
    type: questionsTypes.publish.single,
    payload: response.data
  }
}

const unpublish_question_failure = (messages) => {
  return {
    type: questionsTypes.publish.failure,
    payload: messages
  }
}

const unpublish_question = (question_id, index=true, page=1, per_page=10, filters={}, sort="", order="") => {
  return function(dispatch) {
    // Before Request
    dispatch( unpublish_question_request() )
    const reqParams = index ? {
      index: index,
      page: page,
      per_page: per_page,
      sort: sort,
      order: order,
      filters: filters
    } : {index: index}
    // Request
    axios.post(
      formatRoute(QUESTIONS_ROUTES.unpublish, {id: question_id}),
      reqParams
    ).then( response => {
      window.showSnackbar('success', 'The question status has changed to: Draft.')
      if ( index ) {
        dispatch( unpublish_question_success(response) )

      } else {
        dispatch( unpublish_single_question_success(response) )

      }
    }).catch( error=> {
      // failure
      let errors
      if (error.response && error.response.data && error.response.data.errors) {
        errors = error.response.data.errors
      } else {
        errors = ["Error unpublishing question"]
      }
      dispatch( unpublish_question_failure( errors ) )
    })
  }
}

export {unpublish_question}



// WEBPACK FOOTER //
// ./src/js/actions/questions/unpublish.js